module.exports = __webpack_public_path__ + "img/Annotated_Fire_Map.e660bd67.png";